import { useState } from "react";
import { carouselImages } from "../utils/data";

export default function ImageCarousel() {
  const [index, setIndex] = useState(0);

  const handlePrev = () => {
    setIndex((prevIndex) =>
      prevIndex === 0 ? carouselImages.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setIndex((prevIndex) =>
      prevIndex === carouselImages.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="container mt-5">
      <div className="position-relative">
        <img
          src={carouselImages[index]}
          alt={`Slide ${index + 1}`}
          className="img-fluid w-100 rounded h-80"
          style={{ maxHeight: "500px", height: "200px" }}
        />

        {/* Previous Button */}
        <button
          className="btn position-absolute start-0 top-50 translate-middle-y border border-dark rounded-circle"
          style={{
            backgroundColor: "white",
            color: "black",
            fontSize: "24px",
            fontWeight: "bold",
            borderWidth: "2px",
            transition: "0.3s",
            height: "40px",
            width: "40px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginLeft: "20px",
            boxShadow: "4px 4px 10px rgba(0, 0, 0, 0.2)",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "black";
            e.currentTarget.style.color = "white";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "white";
            e.currentTarget.style.color = "black";
          }}
          onClick={handlePrev}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            width="20"
            height="20"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15.75 19.5 8.25 12l7.5-7.5"
            />
          </svg>
        </button>

        {/* Next Button */}
        <button
          className="btn position-absolute end-0 top-50 translate-middle-y border border-dark rounded-circle shad-x1"
          style={{
            backgroundColor: "white",
            color: "black",
            fontSize: "24px",
            fontWeight: "bold",
            borderWidth: "2px",
            transition: "0.3s",
            height: "40px",
            width: "40px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginRight: "20px",
            boxShadow: "4px 4px 10px rgba(0, 0, 0, 0.2)",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "black";
            e.currentTarget.style.color = "white";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "white";
            e.currentTarget.style.color = "black";
          }}
          onClick={handleNext}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            width="20"
            height="20"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="m8.25 4.5 7.5 7.5-7.5 7.5"
            />
          </svg>
        </button>
      </div>
    </div>
  );
}
